require('../../modules/es6.object.keys');
module.exports = require('../../modules/_core').Object.keys;



//////////////////
// WEBPACK FOOTER
// /Users/zhujian/Desktop/code/live_system/live/~/core-js/library/fn/object/keys.js
// module id = 410
// module chunks = 0